// @flow
import React from "react"
import ExploreButton from "components/ExploreButton"
import HeroSection from "./HeroSection"
import { Inner, Content, Hero, ButtonWrap, Uppercase, StyledText as Text } from "./styled"

const SectionHero = () => (
  <HeroSection>
    <Inner>
      <Content>
        <Hero white>
          <Uppercase>
            The best gear. The best places.
          </Uppercase>
          <Text white lowercase>
            Awayco lets you rent premium equipment around the world so you can live free and travel light.
          </Text>
        </Hero>
        <ButtonWrap>
          <ExploreButton text="Find your gear" fullwidth />
        </ButtonWrap>
      </Content>
    </Inner>
  </HeroSection>
)

export default SectionHero



// WEBPACK FOOTER //
// ./src/pages/Home/SectionHero/index.js